function makeRandomBookGetter() {
  const books = [
    'The Forever War',
    'I Am Legend',
    'Cities in Flight',
    'The Stars My Destination',
    'The Man in the High Castle',
    'Lord of Light',
    'The Fifth Head of Cerberus',
    'Gateway',
    'The Rediscovery of Man',
    'Last and First Men',
    'Earth Abides',
    'The Demolished Men',
    'Stand on Zanzibar',
    'The Dispossessed',
    'The Drowned World',
    'The Sirens of Titan',
    'Emphyrio',
    'A Scanner Darkly',
    'Star Maker',
    'Behold the Men',
    'The Book of Skulls',
    'The Time Machine',
    'The War of the Worlds',
    'Flowers for Algernon',
    'Ubik',
    'Timescape',
    'More Than Human',
    'Man Plus',
    'A Case of Conscience',
    'The Centauri Device',
    'Dr Bloodmoney',
    'The Fountains of Paradise',
    'Pavane',
    'Now Wait for Last Year',
    'Nova',
    'The First Men in the Moon',
    'The City and the Stars',
    'Blood Music',
    'Jem',
    'Bring the Jubilee',
    'VALIS',
    'The Lathe of Heaven',
    'The Complete Roderick',
    'The Invisible Man',
    'Grass',
    'A Fall of Moondust',
    'Eon',
    'The Shrinking Man',
    'The Three Stigmata of Palmer Eldritch',
    'The Dancers at the End of Time',
    'The Space Merchants',
    'Time Out of Joint',
    'Downward to the Earth',
    'The Simulacra',
    'The Penultimate Truth',
    'Dying Inside',
    'Ringworld',
    'The Child Garden',
    'Mission of Gravity',
    'A Maze of Death',
    'Tau Zero',
    'Rendezvous with Rama',
    'Life During Wartime',
    'Where Late the Sweet Birds Sang',
    'Roadside Picnic',
    'Dark Benediction',
    'Mockingbird',
    'Dune',
    'The Moon Is a Harsh Mistress'
  ];
  return function getRandomItem() {
    return books[Math.floor(Math.random() * books.length)];
  };
}

export const getRandomBook = makeRandomBookGetter();
